/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name Xero
 * @description Data access service for managing Xero exporting
 */
angular.module('mercury.modules.stock.xero')
.factory('Xero', ["$q", "$resource", "userinfo", "settings", function($q, $resource, userinfo, settings) {
  var XeroAccounts = $resource(settings.mercHost + '/stock/accounts?system=Xero');
  var XeroContacts = $resource(settings.mercHost + '/stock/contacts?system=Xero');
  var DefaultFreightAccounts = $resource(settings.mercHost + '/stock/accounts/set-default-freight-account?system=Xero');

  var ConnectionStatus = $resource(settings.mercHost + '/connections/xero/status?module=Stock');
  var ConnectionDetach = $resource(settings.mercHost + '/connections/xero/detach');

  var XeroInvoices = $resource(settings.mercHost + '/stock/invoices?system=Xero', null, {
    Statements: {url: settings.mercHost + '/stock/export/statements?system=Xero', method: 'POST', isArray: true},
    PurchaseOrders: {url: settings.mercHost + '/stock/export/purchaseorders', method: 'POST', isArray: true}
  });

  /**
   * new Xero flow to get connection status.
   * Simple angular implementation because most of the workflow is now in React
   * @returns connection status object with connection information
   */
  function getConnectionStatus() {
    return ConnectionStatus.get();
  }

  /**
   * Clear the Xero authentication currently stored
   *
   * @memberof Xero
   */
  function disconnect() {
    return ConnectionDetach.delete().$promise;
  }

  /**
   * Get Xero accounts and contacts to map with Loaded groups and suppliers before exporting
   *
   * @memberof Xero
   */
  function getSupportData() {
    var defer = $q.defer();

    var xeroAccounts = XeroAccounts.query();
    var xeroContacts = XeroContacts.query();

    $q.all([xeroAccounts.$promise, xeroContacts.$promise])
    .then(function() {
      defer.resolve({accounts: xeroAccounts, contacts: xeroContacts});
    }, function(response) {
      defer.reject(response);
    });

    return defer.promise;
  }

  /**
   * Export a list of Purchase Orders to Xero
   *
   * @memberof Xero
   * @param  {Boolean} combine Should these purchase orders be commbined by supplier
   * @param  {Object} ids     Array of purchase order ids
   */
  function exportPurchaseOrders(combine, ids) {
    return XeroInvoices.PurchaseOrders({combine: combine}, ids).$promise;
  }

  /**
   * Export a list of Statements to Xero
   *
   * @memberof Xero
   * @param  {Boolean} combine Should these statements be commbined
   * @param  {Object} ids     Array of statement ids
   */
  function exportStatements(combine, ids) {
    return XeroInvoices.Statements({combine: combine}, ids).$promise;
  }

  /**
   * Update the default Xero freight account
   *
   * @memberof Xero
   * @param {String} xeroAccount New xero freight account
   */
  function setFreightAccountDefault(xeroAccount) {
    var promise = DefaultFreightAccounts.save({xeroAccount: xeroAccount}, {}).$promise;

    promise.then(function() {
      userinfo.companyPreferenceSet({key: 'xero.freightaccount', value: xeroAccount});
    });

    return promise;
  }

  return {
    getConnectionStatus: getConnectionStatus,
    disconnect: disconnect,
    getSupportData: getSupportData,
    exportPurchaseOrders: exportPurchaseOrders,
    exportStatements: exportStatements,
    setFreightAccountDefault: setFreightAccountDefault
  };
}]);
